import { render, staticRenderFns } from "./BasicPage.vue?vue&type=template&id=513c42ac&scoped=true&"
import script from "./BasicPage.vue?vue&type=script&lang=js&"
export * from "./BasicPage.vue?vue&type=script&lang=js&"
import style0 from "./BasicPage.vue?vue&type=style&index=0&id=513c42ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513c42ac",
  null
  
)

export default component.exports